const Advert = require('./advert');

class Advert_Two extends Advert {
  constructor() {
    super();
    this.data;
    this.ex = { qdown: '1', downCh: '343434', qdownCh: '433' };
    this.admData;
    this.GD_params;
    this.DOM;
  }
  renderInPC() {
    const starOne = Number.parseInt(Number.parseInt(this.gameBaseInfo.expertScore) / 2);
    const starHalf = Number.parseInt(this.gameBaseInfo.expertScore) % 2;
    const startZero = 5 - (starOne + starHalf);
    const renderStarOne = () => {
      let result = '';
      for (let i = 0; i < starOne; i++) {
        result += '<span class="one"></span>';
      }
      return result;
    };
    const renderStarHalf = () => {
      let result = '';
      for (let i = 0; i < starHalf; i++) {
        result += '<span class="half"></span>';
      }
      return result;
    };
    const renderStarZero = () => {
      let result = '';
      if (startZero < 0) return;
      for (let i = 0; i < startZero; i++) {
        result += '<span class="zero"></span>';
      }
      return result;
    };

    const renderDownUrl = () => {
      if (this.ex.downCh || this.ex.qdownCh) {
        return `https://sys.assistant.9game.cn/client/pullup?ch=${this.ex.qdownCh}&paramStr=http%3A%2F%2Fweb.9game.cn%2Fshare%3FpageType%3Dgame_detail%26gameId%3D${this.admData.gameId}%26pullUpFrom%3Dag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`;
      } else {
        return `https://sys.assistant.9game.cn/client/pullup?ch=OK_214&paramStr=http%3A%2F%2Fweb.9game.cn%2Fshare%3FpageType%3Dgame_detail%26gameId%3D${this.admData.gameId}%26pullUpFrom%3Dag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`;
      }
      // if (this.ex.downCh || this.ex.qdownCh) {
      //   if (this.ex.qdown === '0' && this.gameBaseInfo.downUrl) {
      //     return `${this.gameBaseInfo.downUrl}?ch=${this.ex.downCh}`;
      //   } else {
      //     return `https://sys.assistant.9game.cn/client/pullup?ch=${this.ex.qdownCh}&paramStr=http%3A%2F%2Fweb.9game.cn%2Fshare%3FpageType%3Dgame_detail%26gameId%3D${this.admData.gameId}%26pullUpFrom%3Dag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`;
      //   }
      // } else {
      //   if (this.gameBaseInfo.typeId === 17 || this.gameBaseInfo.typeId === 19) {
      //     return `https://sys.assistant.9game.cn/client/pullup?ch=OK_214&paramStr=http%3A%2F%2Fweb.9game.cn%2Fshare%3FpageType%3Dgame_detail%26gameId%3D${this.admData.gameId}%26pullUpFrom%3Dag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`;
      //   } else {
      //     return `${this.gameBaseInfo.downUrl}?ch=SO_21`;
      //   }
      // }

    };

    this.DOM = $(`<div class="article-information">
    <div class="article-information-bg">
        <img src="${this.gameBaseInfo.logo}">
    </div>
    <div class="article-information-left stat-recsys-click">
        <a href="${this.gameBaseInfo.gameZone}"  target="_blank" name="uc_gd_adm">
            <img src="${this.gameBaseInfo.logo}">
        </a>
    </div>
    <div class="article-information-center">
        <div class="article-information-center-title stat-recsys-click"><a href="${this.gameBaseInfo.gameZone}" target="_blank" name="uc_gd_adm" ><span class="large">${this.gameBaseInfo.gameName}</span></a>-${this.gameBaseInfo.instruction}</div>
        <div class="article-information-center-line"></div>
        ${this.gameBaseInfo.expertScore ? `<div class="block"><span class="">评分 : <span class="yellow"> ${this.gameBaseInfo.expertScore}</span></span><span class="article-information-star">${renderStarOne()}${renderStarHalf()}${renderStarZero()}</span></div>` : ''}
        <div class=""><span class="">类型 : ${this.gameBaseInfo.category}</span><span class="right">评论 : 已有<span class="yellow"> ${this.gameBaseInfo.commentTotal} </span>条</span>
        </div>
        ${this.gameBaseInfo.androidStatus || this.gameBaseInfo.androidStatus ? `<div class="">${this.gameBaseInfo.androidStatus ? `<span class="">安卓 : ${this.gameBaseInfo.androidStatus}</span>` : ''}${this.gameBaseInfo.iosStatus ? `<span class="right">苹果 : ${this.gameBaseInfo.iosStatus}</span>` : ''}</div>` : ''}
        <div class="article-information-center-button stat-recsys-click"><a href="${this.gameBaseInfo.gameZone}" target="_blank" name="uc_gd_adm" ><span class="">官网</span></a><a href="${this.gameBaseInfo.forum}" class="stat-recsys-click" target="_blank" name="uc_gd_adm" ><span class="">论坛</span></a>
            <a href="${this.gameBaseInfo.tactic}" target="_blank" name="uc_gd_adm" ><span class="">攻略</span></a>
        </div>
    </div>
    <div class="article-information-right">
        <a href="${renderDownUrl()}" target="_blank" name="uc_gd_adm">
            <div class="article-information-button article-information-onButton article-information-android">安卓版下载
                <div class="article-information-code article-information-android-code" data-url="${renderDownUrl()}">
                </div>
            </div>
        </a>
        <a href="javascript:void( 0 )" target="_blank" name="uc_gd_adm">
            <div class="article-information-button article-information-disButton article-information-ios">苹果版暂无下载</div>
        </a>
    </div>
    <img class="article-information-pull" src="https://portal.ucgc.ucfly.com/public/images/pc/template5/article_information/edit_put.png">
    <div class="article-information-mask"></div>
</div>`);
  }

  renderInMobile() {
    const starOne = Number.parseInt(Number.parseInt(this.gameBaseInfo.expertScore) / 2);
    const starHalf = Number.parseInt(this.gameBaseInfo.expertScore) % 2;
    const startZero = 5 - (starOne + starHalf);
    const renderStarOne = () => {
      let result = '';
      for (let i = 0; i < starOne; i++) {
        result += '<span class="one"></span>';
      }
      return result;
    };
    const renderStarHalf = () => {
      let result = '';
      for (let i = 0; i < starHalf; i++) {
        result += '<span class="half"></span>';
      }
      return result;
    };
    const renderStarZero = () => {
      let result = '';
      if (startZero < 0) return;
      for (let i = 0; i < startZero; i++) {
        result += '<span class="zero"></span>';
      }
      return result;
    };
    this.DOM = $(`<div><div class="m-ad-2" ${this.IsInPc() ? '' : 'type="xlyx-count-item"'} data-game-id="${this.admData.gameId}" data-game-name="${this.gameBaseInfo.gameName}">
  <div class="m-ad-2-bg">
    <img src="${this.gameBaseInfo.logo}" />
  </div>
  <div class="m-ad-2-icon stat-recsys-click href-to-gamezone">
    <img src="${this.gameBaseInfo.logo}" />
  </div>
  <div class="m-ad-2-info stat-recsys-click href-to-gamezone">
    <div class="m-ad-2-info-title">${this.gameBaseInfo.gameName}</div>
    <div class="m-ad-2-info-detail">${this.gameBaseInfo.category}<span class="m-ad-2-info-detail-line">|</span>${this.gameBaseInfo.fileSize}</div>
    <div class="m-ad-2-info-abstract">${this.gameBaseInfo.instruction}</div>
    <div class="m-ad-2-info-score">
    ${this.gameBaseInfo.expertScore ? `<div class="m-ad-2-info-score-star">${renderStarOne()}${renderStarHalf()}${renderStarZero()}</div>` : ''}
    </div>
  </div>
  <div  class="${this.IsInPc() ? '' : 'game-recommend-download'} m-ad-2-download ${this.ex.qdown === '0' ? 'stat-recsys-down' : 'stat-recsys-app-down'}">${this.gameBaseInfo.packageproperty ? '下载' : '预约'}</div>
</div><!--*{游戏推荐 下了又下模块}*-->${this.renderXlyx()}</div>`);
  }

  SetDOM() {
    if (this.IsInPc()) {
      this.renderInPC();
    } else {
      this.renderInMobile();
      this.InitEvent();
    }
  }

  InitEvent() {
    this.InitButtonEvent();
  }

  InitButtonEvent() {
    this.DOM.find('.m-ad-2-download').on('click', e => {
      if (this.gameBaseInfo.typeId === 17 || this.gameBaseInfo.typeId === 19) {
        this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, 'OK_214', this.gameBaseInfo.packageproperty);
      } else {
        const ch = this.ex.qdownCh || 'OK_2432';
        this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, ch, this.gameBaseInfo.packageproperty);
      }
      // if (this.ex.downCh || this.ex.qdownCh) {
      //   if (this.ex.qdown === '0' && this.gameBaseInfo.downUrl) {
      //     window.location = this.gameBaseInfo.downUrl + `?ch=${this.ex.downCh}`;
      //   } else {
      //     this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, this.ex.qdownCh, this.gameBaseInfo.packageproperty);
      //   }
      // } else {
      //   if (this.gameBaseInfo.typeId === 17 || this.gameBaseInfo.typeId === 19) {
      //     this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, 'OK_214', this.gameBaseInfo.packageproperty);
      //   } else {
      //     window.location = this.gameBaseInfo.downUrl + '?ch=SO_21';
      //   }
      // }
    });
  }
}

module.exports = Advert_Two;


// WEBPACK FOOTER //
// ./lib/js/module/m_advert/module/advert_two.js